import React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { RootState } from '@Redux/detail/store';
import { RootState as C_RootState } from '@Redux/common/store';
import { TravelTypes } from '@Redux/detail/Group/interfaces';
import styles from '../styles.module.scss';
import { getWeekday } from '@utils/utils';

function DetailList() {
    const group = useSelector((state: RootState) => state.groupReducer);
    const PricesInfo = useSelector((state: RootState) => state.groupReducer.PricesInfo);
    const { curPage } = useSelector((state: C_RootState) => state.pageReducer);
    const { t } = useTranslation();

    return (
        <>
            <div className={styles['group-name']}>{group.GroupInfo.TourName}</div>
            <ul className={styles['detail-list']}>
                {curPage !== 'print' && (
                    <>
                        <li>
                            {t('GroupID')}：{PricesInfo!.GroupID}{' '}
                            {PricesInfo!.IsCutPrice && (
                                <span className={styles.discount}>特惠</span>
                            )}
                        </li>

                        <li className={styles['detail-item']}>
                            <span className={styles['detail-item__title']}>出發日期：</span>
                            <span>
                                {getWeekday(PricesInfo!.GoDate!)} ~{' '}
                                {getWeekday(PricesInfo!.BackDate!)} 共 {PricesInfo!.TourDays} 天
                            </span>
                        </li>
                    </>
                )}
                <li>
                    {PricesInfo?.IsFullPay ? (
                        '須全額付清'
                    ) : (
                        <>
                            應付訂金：
                            <span className={styles['detail-item__payment-content']}>
                                {PricesInfo?.CurrencyCode || ''}&thinsp;
                                {PricesInfo?.OrderPrice?.toLocaleString()}
                            </span>
                        </>
                    )}
                    {PricesInfo!.IsImmediatePay && (
                        <span className={styles['detail-item__payment-all']}>應立即付款</span>
                    )}
                </li>
                {/* {storyData!.TravelType === TravelTypes.GroupFree && (
                <li>
                    <span className={styles['detail-item__title']}>回程當日：</span>
                    <div className={styles['detail-item__content']}>
                        【嬰兒】 未滿2歲之幼兒；【小孩】 2-12歲之小朋友；【大人】 滿12歲以上之旅客。
                        <br />
                        本售價按該行程所有出發日期中最低價格的費用，您最後的價格會依出發日期、出行人數、所選飯店或艙房而有所不同。
                    </div>
                </li>
            )} */}
                <li>
                    <span className={styles['detail-item__title']}>回程當日：</span>
                    <div className={styles['detail-item__content']}>
                        【嬰兒】 未滿2歲之幼兒；【小孩】 2-12歲之小朋友；【大人】 滿12歲以上之旅客。
                        {PricesInfo!.TravelType === TravelTypes.GroupFree && (
                            <>
                                <br />
                                本售價按該行程所有出發日期中最低價格的費用，您最後的價格會依出發日期、出行人數、所選飯店或艙房而有所不同。
                            </>
                        )}
                    </div>
                </li>
            </ul>
        </>
    );
}

export default DetailList;
